import ahoy from 'ahoy.js'

ahoy.configure({
  cookies: false
})

ahoy.trackAll();